export var PATHS;
(function (PATHS) {
    PATHS["LANDING"] = "/";
    PATHS["REPORT_TYPE"] = "/report-type";
    PATHS["CHECKOUT"] = "/checkout";
    PATHS["LOGIN"] = "/login";
    PATHS["DEMO"] = "/demo";
    PATHS["FORGOT_PASSWORD"] = "/forgot-password";
    PATHS["RESET_PASSWORD"] = "/reset-password";
    PATHS["LOGIN_ERROR"] = "/login/login-error";
    PATHS["AUTH_ERROR"] = "/auth-error";
    PATHS["HOME"] = "/home";
    PATHS["PLANS_BILLING"] = "/plans-and-billing";
    PATHS["ACCOUNT_SETTINGS"] = "/account-settings";
    PATHS["OVERVIEW"] = "/overview/:assessmentId";
    PATHS["RESULTS"] = "/results/:assessmentId";
    PATHS["ADMIN_DASHBOARD"] = "/admin/dashboard";
    PATHS["TERMS_CONDITIONS_AGREEMENT"] = "/terms-conditions-agreement";
    PATHS["COMMUNITY"] = "/community/:communityId";
    PATHS["NEW_REPORT"] = "/new-report";
    PATHS["REPORT_SETTINGS"] = "/report/:reportId";
    PATHS["REPORT_SETTINGS_TOPICS"] = "/report/:reportId/settings/topics-and-subtopics";
    PATHS["REPORT_SETTINGS_COMPETITORS"] = "/report/:reportId/settings/tracked-competitors";
    PATHS["INVALID_TOKEN"] = "/invalid-token";
    PATHS["RESTRICTED"] = "/restricted";
    PATHS["EMBED_SIGNUP"] = "/embed/signup";
    PATHS["SELECT_ORGANIZATION"] = "/select-organization";
})(PATHS || (PATHS = {}));
/** Route-tree segment that scopes member routes to the active organization. */
export const ORG_SEGMENT = "/o/:orgId";
/**
 * Prefixes a path with the active org's `/o/:orgId` segment. Accepts either a `PATHS` enum
 * value or an already-resolved path string (e.g. a dynamic path with params filled in). Idempotent:
 * a path already scoped under `/o/` is returned unchanged rather than double-prefixed.
 */
export const buildOrgPath = (orgId, path) => {
    const suffix = String(path);
    if (suffix.startsWith("/o/"))
        return suffix;
    return `/o/${orgId}${suffix}`;
};
/** `?plan=` value that sends checkout down the no-card free report branch. */
export const FREE_PLAN = "free";
export const buildFreeCheckoutPath = (orgId) => `${buildOrgPath(orgId, PATHS.CHECKOUT)}?plan=${FREE_PLAN}`;
